import config from "../config";

const API_BASE_URL = String(config.apiBaseUrl || "").replace(/\/+$/, "");

export function getToken() {
  return localStorage.getItem("token") || "";
}

export async function authFetch(path, options = {}) {
  const token = getToken();

  const headers = new Headers(options.headers || {});
  if (!headers.has("Authorization") && token) {
    headers.set("Authorization", `Bearer ${token}`);
  }

  // si NO es FormData, por defecto JSON
  const isFormData = options.body instanceof FormData;
  if (!isFormData && options.body && !headers.has("Content-Type")) {
    headers.set("Content-Type", "application/json");
  }

  const url = path.startsWith("http") ? path : `${API_BASE_URL}${path}`;
  return fetch(url, { ...options, headers });
}